module.exports = __webpack_public_path__ + "static/media/roof_top_jbjhgb56.f89c94b3.png";